
import apiRequest from "./apiRequest";

export const ChG7RegisterApi = {

    fetchch7Register: (accountId, token) => {
    return apiRequest(`/api/register/ch7?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitCh7Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/ch7?accountId=${accountId}`, 'POST', token, formData);
  },

    addNewRegisterOfCharge: (id, payload, token) => {
      return apiRequest(
        `/api/register/ch7/add-new/register-of-charge/${id}`,
        "POST",
        token,
        payload          // ← body is forwarded as-is to apiRequest
      );
    },
  

 

  
};